import AddBulkMembersModal from './AddBulkMembersModal.component';

export default AddBulkMembersModal;
